import { Controller } from "@hotwired/stimulus"

// Ensures Trix editor commits its content before form submission
export default class extends Controller {
  connect() {
    console.log("Trix form controller connected")
    // Listen to turbo:submit-start event (before form is submitted)
    this.element.addEventListener('turbo:submit-start', this.handleSubmit.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-start', this.handleSubmit.bind(this))
  }

  handleSubmit(event) {
    console.log("Trix form submit handler triggered")
    
    // Find all trix editors in the form
    const trixEditors = this.element.querySelectorAll('trix-editor')
    console.log("Found trix editors:", trixEditors.length)
    
    // Force each trix editor to save its content to the hidden input
    trixEditors.forEach(editor => {
      console.log("Processing trix editor:", editor)
      
      // Get the editor instance
      if (editor.editor) {
        const content = editor.editor.getDocument().toString()
        console.log("Trix content:", content)
        
        // Find the associated input field
        const inputId = editor.getAttribute('input')
        if (inputId) {
          const input = document.getElementById(inputId)
          if (input) {
            console.log("Updating input:", inputId, "with content:", content)
            input.value = content
          }
        }
      }
    })
  }
}

